module.exports = __webpack_public_path__ + "static/media/logo-texto.9c16d13d.png";